import { createSelector } from '@reduxjs/toolkit';
import { emptyArr, emptyObj } from '@beef/utils';
import { createCurrentSelector } from '@beef/redux';
import { selectHeader, selectHeaderCommonData } from "../../common";
import { getBannerKey, getCardKey } from "../../../components/Search/utils/getKey";
import { selectIsWebView } from "../layout/selectors";
import { STEP } from "../../../components/Search/utils/constants";
import { getSearchPageUrl } from "../../../components/Search/utils/getSearchPageUrl";
export var selectSearch = createSelector(selectHeader, function (data) {
  return data.search || emptyObj;
});
export var selectSearchContent = createSelector(selectHeaderCommonData, function (data) {
  return data.search || emptyObj;
});
var SEARCH_URL = '/search/';
export var selectSearchResultsPageUrl = createSelector(selectSearchContent, function (data) {
  return data.searchResultsPageUrl || SEARCH_URL;
});
var selectDefaults = createSelector(selectSearchContent, function (data) {
  return data.defaults || emptyObj;
});
export var selectBanners = createSelector(selectDefaults, function (data) {
  return data.banners || emptyObj;
});
export var selectBannerList = createSelector(selectBanners, function (data) {
  return data.items || emptyArr;
});
export var selectHistoryContent = createSelector(selectSearchContent, function (data) {
  return data.searchHistory || emptyObj;
});
export var selectCookieDomain = createSelector(selectSearchContent, function (flag) {
  return flag.cookieDomain;
});
export var selectRequestUrl = createSelector(selectSearchContent, selectIsWebView, function (data, isWebView) {
  return isWebView ? data.webViewAutocompleteUrl : data.digineticaAutocompleteUrl;
});
export var selectError = createSelector(selectSearch, function (data) {
  return data.error;
});
export var selectContentErrorText = createSelector(selectDefaults, function (data) {
  return data.contentErrorText;
});
export var selectContentEmptyText = createSelector(selectDefaults, function (data) {
  return data.contentEmptyText;
});
export var selectIsLoading = createSelector(selectSearch, function (data) {
  return data.isLoading;
});
export var selectTaps = createSelector(selectSearch, function (data) {
  return data.taps;
});
export var selectIsOpenSidebar = createSelector(selectSearch, function (data) {
  return data.isOpenSidebar;
});
export var selectQuery = createSelector(selectSearch, function (data) {
  return data.query || '';
});
var selectAnyQueryData = createSelector(selectSearch, function (data) {
  return data.anyQueryData;
});
export var selectCorrection = createSelector(selectSearch, function (data) {
  return data.correction || data.query;
});
export var selectStep = createSelector(selectSearch, function (data) {
  return data.step;
});
export var selectElk = createSelector(selectAnyQueryData, function (data) {
  return data.elk || emptyArr;
});
export var selectTariffs = createSelector(selectAnyQueryData, function (data) {
  return data.tariffs || emptyArr;
});
export var selectProducts = createSelector(selectAnyQueryData, function (data) {
  return data.products || emptyArr;
});
export var selectServices = createSelector(selectAnyQueryData, function (data) {
  return data.services || emptyArr;
});
export var selectOther = createSelector(selectAnyQueryData, function (data) {
  return data.others || emptyArr;
});
export var selectIsEmptyResponse = createSelector(selectAnyQueryData, function (data) {
  return data.isEmpty;
});
export var selectIsRenderBanner = createSelector(selectBanners, selectIsLoading, selectError, selectStep, function (bannerData, isLoading, _ref, step) {
  var _bannerData$items;
  var message = _ref.message;
  return bannerData.isEnabled && !!((_bannerData$items = bannerData.items) !== null && _bannerData$items !== void 0 && _bannerData$items.length) && !isLoading && !message && step === STEP.recently;
});
export var selectIsRenderAllResult = createSelector(selectStep, selectIsLoading, selectError, selectIsEmptyResponse, function (step, isLoading, _ref2, isEmpty) {
  var message = _ref2.message;
  return step === STEP.result && !isLoading && !message && !isEmpty;
});
export var selectIsRenderHistory = createSelector(selectError, selectIsEmptyResponse, function (_ref3, isEmpty) {
  var message = _ref3.message;
  return !message && !isEmpty;
});
export var selectAllResultUrl = createSelector(selectCorrection, selectSearchResultsPageUrl, function (query, url) {
  return getSearchPageUrl({
    url: url,
    query: query
  });
});
export var selectIsRenderResultBlock = createSelector(selectStep, function (step) {
  return step === STEP.result;
});
export var selectIsRenderRecentlyBlock = createSelector(selectStep, selectProducts, function (step, list) {
  return step === STEP.recently && !!(list !== null && list !== void 0 && list.length);
});
var _createCurrentSelecto = createCurrentSelector(selectProducts, getCardKey),
  currentCardProduct = _createCurrentSelecto.selectCurrent,
  withCardsProductsMapper = _createCurrentSelecto.withCurrentProviderMapper;
export { currentCardProduct, withCardsProductsMapper };
var _createCurrentSelecto2 = createCurrentSelector(selectTariffs, getCardKey),
  selectCurrentTariff = _createCurrentSelecto2.selectCurrent,
  withCardsTariffsMapper = _createCurrentSelecto2.withCurrentProviderMapper;
export { selectCurrentTariff, withCardsTariffsMapper };
var _createCurrentSelecto3 = createCurrentSelector(selectElk, getCardKey),
  selectCurrentElk = _createCurrentSelecto3.selectCurrent,
  withCardsElkMapper = _createCurrentSelecto3.withCurrentProviderMapper;
export { selectCurrentElk, withCardsElkMapper };
var _createCurrentSelecto4 = createCurrentSelector(selectOther, getCardKey),
  selectCurrentOther = _createCurrentSelecto4.selectCurrent,
  withOthersMapper = _createCurrentSelecto4.withCurrentProviderMapper;
export { selectCurrentOther, withOthersMapper };
var _createCurrentSelecto5 = createCurrentSelector(selectServices, getCardKey),
  selectCurrentService = _createCurrentSelecto5.selectCurrent,
  withCardsServicesMapper = _createCurrentSelecto5.withCurrentProviderMapper;
export { selectCurrentService, withCardsServicesMapper };
var _createCurrentSelecto6 = createCurrentSelector(selectBannerList, getBannerKey),
  selectCurrentBanner = _createCurrentSelecto6.selectCurrent,
  withBannersMapper = _createCurrentSelecto6.withCurrentProviderMapper;
export { selectCurrentBanner, withBannersMapper };
export var selectPureCorrection = createSelector(selectSearch, function (data) {
  return data.correction;
});
var selectBannerStyles = createSelector(selectCurrentBanner, function (styles) {
  return styles.styles || emptyObj;
});
export var selectBannerButtonArrowColor = createSelector(selectBannerStyles, function (styles) {
  return styles.arrowColor;
});
export var selectBannerButtonCircleTheme = createSelector(selectBannerStyles, function (styles) {
  return styles.circleTheme || 'dark';
});
export var selectBannerTitleColor = createSelector(selectBannerStyles, function (styles) {
  return styles.titleColor;
});
export var selectBannerBackgroundTheme = createSelector(selectBannerStyles, function (styles) {
  return styles.backgroundTheme || 'dark';
});